// import { isPureHost } from '@rendora/common/utils/config';

export const jumpTo = (url: string, target: '_blank' | '_self' = '_blank') => {
  // if (isPureHost()) {
  // location.href = url;
  // return;
  // }
  window.open(url, target);
};
